  document.addEventListener("DOMContentLoaded", function() {

    
    // Data for size comparison
    const sizeComparisonData = {
      0: { aus: 6, usa: 2, uk: 6, fra: 34, nz: 6 },
      1: { aus: 8, usa: 4, uk: 8, fra: 36, nz: 8 },
      2: { aus: 10, usa: 6, uk: 10, fra: 38, nz: 10 },
      3: { aus: 12, usa: 8, uk: 12, fra: 40, nz: 12 },
      4: { aus: 14, usa: 10, uk: 14, fra: 42, nz: 14 }
    };

// Function to update the size comparison table
function updateSizeComparisonTable(selectedSize) {
  const data = sizeComparisonData[selectedSize];
  
  if (data) {
    const natalieSizeElement = document.getElementById("natalie-size");
    if (natalieSizeElement) natalieSizeElement.innerText = selectedSize;

    const ausSizeElement = document.getElementById("aus-size");
    if (ausSizeElement) ausSizeElement.innerText = data.aus;

    const usaSizeElement = document.getElementById("usa-size");
    if (usaSizeElement) usaSizeElement.innerText = data.usa;

    const ukSizeElement = document.getElementById("uk-size");
    if (ukSizeElement) ukSizeElement.innerText = data.uk;

    const fraSizeElement = document.getElementById("fra-size");
    if (fraSizeElement) fraSizeElement.innerText = data.fra;

    const nzSizeElement = document.getElementById("nz-size");
    if (nzSizeElement) nzSizeElement.innerText = data.nz;
  }
}
    // Initialize the table on page load with the default size
    updateSizeComparisonTable(0);

    // Event listener for size change
    document.querySelectorAll('input[name="size"]').forEach(function(sizeRadio) {
      sizeRadio.addEventListener("change", function() {
        let selectedSize = this.value;
        updateSizeComparisonTable(selectedSize);
      });
    });

    // Function to convert cm to inches
    const CM_TO_INCH_FACTOR = 0.393701;
    function convertToInches(cm) {
      return (cm * CM_TO_INCH_FACTOR).toFixed(1).replace(/\.0$/, '');
    }

    // Function to clean and split the string into an array
    function extractData(dataString) {
      return dataString.replace(/[`"&quot;\[\]]/g, "").split(",");
    }

    // Event listener for unit change (CM to INCH)
    document.querySelectorAll('input[name="unit"]').forEach(function(unitRadio) {
      unitRadio.addEventListener("change", function() {
        let unit = this.value;
        updateMeasurementTable(unit);
      });
    });

    // Event listener for size change
    document.querySelectorAll('input[name="size"]').forEach(function(sizeRadio) {
      sizeRadio.addEventListener("change", function() {
        let selectedUnit = document.querySelector('input[name="unit"]:checked').value;
        updateMeasurementTable(selectedUnit);
      });
    });

// Function to update the measurement table based on the unit and size
function updateMeasurementTable(unit) {
  // Get the selected size
  let selectedSizeElement = document.querySelector('input[name="size"]:checked');
  let selectedSize = selectedSizeElement ? selectedSizeElement.value : null;

  if (selectedSize) {
    // Get the data from the data attributes and extract them
    let wrapper = document.querySelector(".size-guide-wrapper");
    if (wrapper) {
      let bustValues = extractData(wrapper.getAttribute("data-bust"));
      let waistValues = extractData(wrapper.getAttribute("data-waist"));
      let hipsValues = extractData(wrapper.getAttribute("data-hips"));
      let lengthAValues = extractData(wrapper.getAttribute("data-length-a"));
      let lengthBValues = extractData(wrapper.getAttribute("data-length-b"));

      // Set the values based on size and unit, with unit display
      const unitLabel = unit === "inch" ? " IN" : " CM";

      const bustValueElement = document.getElementById("bust-value");
      if (bustValueElement) {
        bustValueElement.innerText = (unit === "inch" ? convertToInches(bustValues[selectedSize]) : bustValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }

      const waistValueElement = document.getElementById("waist-value");
      if (waistValueElement) {
        waistValueElement.innerText = (unit === "inch" ? convertToInches(waistValues[selectedSize]) : waistValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }

      const hipsValueElement = document.getElementById("hips-value");
      if (hipsValueElement) {
        hipsValueElement.innerText = (unit === "inch" ? convertToInches(hipsValues[selectedSize]) : hipsValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }

      const lengthAValueElement = document.getElementById("length-a-value");
      if (lengthAValueElement) {
        lengthAValueElement.innerText = (unit === "inch" ? convertToInches(lengthAValues[selectedSize]) : lengthAValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }

      const lengthBValueElement = document.getElementById("length-b-value");
      if (lengthBValueElement) {
        lengthBValueElement.innerText = (unit === "inch" ? convertToInches(lengthBValues[selectedSize]) : lengthBValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }
    }
  }
}


    // Initialize the measurement table on page load with CM as the default unit
    updateMeasurementTable("cm");

const sizeGuideButton = document.querySelector(".size-guide-button");
    if(sizeGuideButton){
// Functionality for opening and closing the size guide drawer
sizeGuideButton.addEventListener("click", function() {
  const drawer = document.querySelector(".size-guide-wrapper");
  const productTemplate = document.querySelector(".template-product");
  
  drawer.classList.toggle("active"); // Toggle the active class to slide in/out

  // Add or remove new class to/from .template-product based on drawer state
  if (drawer.classList.contains("active")) {
    productTemplate.classList.add("size-guide-active");
  } else {
    productTemplate.classList.remove("size-guide-active");
  }
});
    
const closeButton = document.querySelector(".close svg");
closeButton.addEventListener("click", function() {
  const drawer = document.querySelector(".size-guide-wrapper");
  const productTemplate = document.querySelector(".template-product");

  drawer.classList.remove("active"); // Close the drawer
  productTemplate.classList.remove("size-guide-active"); // Remove class from .template-product
});

// Close the drawer when clicking outside of it
document.addEventListener("click", function(event) {
  const drawer = document.querySelector(".size-guide-wrapper");
  const button = document.querySelector(".size-guide-button");
  const productTemplate = document.querySelector(".template-product");

  // Check if the click is outside the drawer and button
  if (!drawer.contains(event.target) && !button.contains(event.target)) {
    drawer.classList.remove("active"); // Close the drawer
    productTemplate.classList.remove("size-guide-active"); // Remove class from .template-product
  }
});
    }
  });


document.addEventListener('DOMContentLoaded', function() {
  function setDispatchDate(elementSelector, targetSelector, additionalDaysStart, additionalDaysEnd) {
    const element = document.querySelector(elementSelector);
    if (element) {
      const targetElement = element.querySelector(targetSelector) || document.querySelector(targetSelector);
      if (targetElement) {
        const startDate = calculateNextWeekday(new Date(), additionalDaysStart);
        const endDate = calculateNextWeekday(new Date(), additionalDaysEnd);

        const options = { month: 'long', day: 'numeric' };
        targetElement.textContent = `${startDate.toLocaleDateString(undefined, options)} - ${endDate.toLocaleDateString(undefined, options)}`;
      }
    }
  }

  function setSingleDispatchDate(elementSelector, targetSelector, additionalDays) {
    const element = document.querySelector(elementSelector);
    if (element) {
      const targetElement = element.querySelector(targetSelector) || document.querySelector(targetSelector);
      if (targetElement) {
        const date = calculateNextWeekday(new Date(), additionalDays);

        const options = { month: 'long', day: 'numeric' };
        targetElement.textContent = date.toLocaleDateString(undefined, options);
      }
    }
  }

  /** #dispatch-date-input in product-form.liquid 

  function setSingleDispatchDate(elementSelector, targetSelector, additionalDays) {
    const element = document.querySelector(elementSelector);
    if (element) {
      const targetElement = element.querySelector(targetSelector) || document.querySelector(targetSelector);
      if (targetElement) {
        const date = calculateNextWeekday(new Date(), additionalDays);

        const options = { month: 'long', day: 'numeric' };
        const formattedDate = date.toLocaleDateString(undefined, options);

        targetElement.textContent = formattedDate;

        // Set hidden input value to send to cart
        const dispatchInput = document.querySelector('#dispatch-date-input');
        if (dispatchInput) {
          dispatchInput.value = formattedDate;
        }
      }
    }
  }
  */

  function calculateNextWeekday(currentDate, additionalDays) {
    const date = new Date(currentDate);
    date.setDate(date.getDate() + additionalDays);

    // If date falls on Saturday (6) or Sunday (0), adjust to next Monday
    if (date.getDay() === 6) {
      // If Saturday, add 2 days
      date.setDate(date.getDate() + 2);
    } else if (date.getDay() === 0) {
      // If Sunday, add 1 day
      date.setDate(date.getDate() + 1);
    }

    return date;
  }

  // Get the element by ID
  const dispatchDateElement = document.querySelector('#dispatch-date');
  
// Check if the element exists and get the data-date attribute
let madeToOrder = 28; // Default value
if (dispatchDateElement) {
  const dataDate = dispatchDateElement.getAttribute('data-date');
  madeToOrder = dataDate ? parseInt(dataDate, 10) : 28; // Fallback to 28 if data-date is invalid
  console.log('Made-to-Order Date:', madeToOrder);
} else {
  console.error('#dispatch-date element not found, using default value:', madeToOrder);
}

  // Set dispatch date for made-to-order items (20 to 28 days range)
  setSingleDispatchDate('.made-to-order', '#dispatch-date', madeToOrder);
  // Set dispatch date for made-to-order items (20 to 28 days range)
  setSingleDispatchDate('.made-to-order', '#dispatch-date_mobile', madeToOrder);

  // Set dispatch date for ready-to-wear items (single value, 1 day)
  setSingleDispatchDate('.ready-to-wear', '#dispatch-date-rtw', 1);
  // Set dispatch date for ready-to-wear items (single value, 1 day)
  setSingleDispatchDate('.ready-to-wear', '#dispatch-date-rtw_mobile', 1);
});



// -----------------------------------------------------------------------------
// MIGRATED: legacy `updateGalleryForSelectedVariant` Color → gallery filter +
// its click listener + DOMContentLoaded initial run was here. Removed because:
// (1) It used `[data-value="${color}"]` which broke for 3-segment alt-text
//     (last-segment parse made `EvangelineGown_IceBlue_Espresso` map to
//     data-value="espresso" — never matched Color=Ice Blue).
// (2) It conflicted with the new GalleryController (style-with.js) which is
//     the single source of truth for gallery visibility (Color × Undergarment
//     × Style-With Set state).
// Side effects (`.colorUnavailable` message + `.is_color_info` unavailable-span)
// were already commented out in the original — net loss = nothing observable.
// See _projects/natalie-rolt/CUSTOMIZATIONS.md.
// -----------------------------------------------------------------------------



document.addEventListener('DOMContentLoaded', function() {
  // Select both the Size and Color radio inputs
  var variantRadios = document.querySelectorAll('.product-single__form input[name="Size"],.product-single__form input[name="Color"]');

  // Listen for change events on these radio inputs
  variantRadios.forEach(function(radio) {
    radio.addEventListener('change', updateVariantSelection);
  });

  function updateVariantSelection() {
    // Get the currently checked values for Size and Color
    var selectedSize = document.querySelector('input[name="Size"]:checked').value;
    var selectedColor = document.querySelector('input[name="Color"]:checked').value;

    // Build the search key (e.g., "4 / Lemon")
    var searchKey = selectedSize + " / " + selectedColor;

    // Get the main product <select> element that holds all variant options
    var selectEl = document.querySelector('.product-single__variants');
    var isAvailable = false;

    // Loop through the main <select> options to find the matching variant
    for (var i = 0; i < selectEl.options.length; i++) {
      var optionText = selectEl.options[i].textContent.trim();

      // If the variant text starts with "Size / Color"
      if (optionText.indexOf(searchKey) === 0) {
        // Set the selected index for the main product <select>
        selectEl.selectedIndex = i;

        // Update the product price element using the data-price attribute
        var newPriceHTML = selectEl.options[i].getAttribute('data-price');
        document.querySelector('.title_price_wrapper .product__price:not(.product__price--compare)').innerHTML = newPriceHTML;

        // Determine if the variant is available (disabled means sold out)
        isAvailable = !selectEl.options[i].disabled;
        console.log("Variant is available:", isAvailable);

        // Also update the modal's <select> if it exists
        var modalSelect = document.getElementById("variants");
        if (modalSelect) {
          for (var j = 0; j < modalSelect.options.length; j++) {
            var modalOptionText = modalSelect.options[j].textContent.trim();
            if (modalOptionText.indexOf(searchKey) === 0) {
              modalSelect.selectedIndex = j;
              break;
            }
          }
        }

        // Break once the matching option is found
        break;
      }
    }

    // --- Add-to-Cart / BIS button toggle logic ---
     const bisBtn = document.querySelector('.product-single__form #BIS_trigger');

  function toggleButtons() {
    const addToCartBtn = document.querySelector('.product-single__form .add-to-cart:not(#BIS_trigger)');
    const available = typeof isAvailable !== 'undefined' ? isAvailable : true;

    console.log('[Toggle] BIS button found:', !!bisBtn);
    console.log('[Toggle] Add-to-Cart button found:', !!addToCartBtn);
    console.log('[Toggle] Product availability:', available);

    if (!addToCartBtn) {
      console.warn('[Toggle] No .add-to-cart button found in DOM.');
      return;
    }

    const addToCartText = addToCartBtn.querySelector('span');
    console.log('[Toggle] Add-to-Cart text element found:', !!addToCartText);

    if (bisBtn) {
      if (!available) {
        addToCartBtn.classList.add('disabled');
        bisBtn.classList.remove('disabled');
        console.log('[Toggle] Showing BIS button, disabling Add-to-Cart.');
      } else {
        addToCartBtn.classList.remove('disabled');
        bisBtn.classList.add('disabled');
        console.log('[Toggle] Hiding BIS button, enabling Add-to-Cart.');
      }
    } else {
      if (!available) {
        addToCartBtn.classList.add('disabled');
        if (addToCartText) {
          addToCartText.textContent = 'SOLD OUT';
          console.log('[Toggle] Product unavailable. Set button text to SOLD OUT.');
        }
      } else {
        addToCartBtn.classList.remove('disabled');
        if (addToCartText) {
          const defaultText = addToCartText.getAttribute('data-default-text') || 'ADD TO CART';
          addToCartText.textContent = defaultText;
          console.log('[Toggle] Product available. Reset button text to:', defaultText);
        }
      }
    }
  }

  function waitForButtonAndToggle(maxRetries = 20) {
    let retries = 0;
    const interval = setInterval(() => {
      const btn = document.querySelector('.product-single__form .add-to-cart:not(#BIS_trigger)');
      if (btn || retries >= maxRetries) {
        clearInterval(interval);
        toggleButtons(); // Safe to call; includes null check
      } else {
        console.log(`[Retry] Attempt ${retries + 1}: .add-to-cart not found yet`);
        retries++;
      }
    }, 100); // Check every 100ms (2s max)
  }

  waitForButtonAndToggle();

    //  New step: Toggle .disabled on Size labels based on availability
    toggleSizeLabels(selectedColor);
  }

  /**
   * Loop through each Size input/label and see if
   * "Size / selectedColor" is available. If not, add .disabled
   * to its label. Otherwise, remove .disabled.
   */
  function toggleSizeLabels(selectedColor) {
    var selectEl = document.querySelector('.product-single__variants');
    var sizeRadios = document.querySelectorAll('input[name="Size"]');

    sizeRadios.forEach(function(radio) {
      var sizeValue = radio.value;
      var labelEl = document.querySelector('label[for="' + radio.id + '"]');
      if (!labelEl) return; // safety check

      // Build the text we expect in the <option> (e.g., "4 / Espresso")
      var comboText = sizeValue + " / " + selectedColor;
      var isComboAvailable = false;

      // Check all <option> elements to see if "comboText" is found and not disabled
      for (var i = 0; i < selectEl.options.length; i++) {
        var optText = selectEl.options[i].textContent.trim();
        if (optText.indexOf(comboText) === 0 && !selectEl.options[i].disabled) {
          isComboAvailable = true; // found a matching enabled variant
          break;
        }
      }

      // Toggle the .disabled class on the label based on availability
      if (!isComboAvailable) {
        labelEl.classList.add('disabled');
      } else {
        labelEl.classList.remove('disabled');
      }
    });
  }

}); // end DOMContentLoaded

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const buttons = document.querySelectorAll('.add-to-cart');
    if (buttons.length === 0) return;

    const observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          mutation.target.removeAttribute('style');
        }
      }
    });

    buttons.forEach(button => {
      if (button.hasAttribute('style')) {
        button.removeAttribute('style');
      }
      observer.observe(button, { attributes: true });
    });
  }, 100); // 100ms delay helps Safari
});

// -----------------------------------------------------------------------------
// MIGRATED: legacy .style-with__link click handler (dyn-anchor injector) was
// here. It was removed because its responsibilities — picking a variant from
// the linked-product card, injecting a #dyn-{handle} anchor into the gallery,
// and toggling visibility of other anchors — now live in the unified
// GalleryController in assets/style-with.js. The new controller treats Color,
// Undergarment, and styleSetHandle as a single state and prevents the race
// that existed when both this handler and setGallerySwitching responded to
// the same click. See _projects/natalie-rolt/CUSTOMIZATIONS.md.
// -----------------------------------------------------------------------------


/* ============================================================================
# Variant → Dispatch Date Hook (non-invasive)
# - Listens to the SAME change events your radios already use.
# - Runs AFTER your updateVariantSelection by using setTimeout(..., 0).
# - Also listens to the main variant <select> changes, just in case.
# - Uses #variant-processing-time-json when present; else falls back to
#   #dispatch-date[data-date].
# - Writes to #dispatch-date and #dispatch-date_mobile.
# - Verbose console logs for each step.
# ========================================================================== */
(function VariantDispatchHook(){
  const LOGP = "[dispatch-hook]";

  // --- helpers --------------------------------------------------------------
  function safeParseJSON(text, fallback) {
    try { return JSON.parse(text); } catch (e) { console.warn(LOGP, "JSON parse failed:", e); return fallback; }
  }
  function toInt(v) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : null;
  }
  function calcNextWeekday(additionalDays) {
    const add = Number.isFinite(additionalDays) ? additionalDays : 0;
    const d = new Date();
    d.setDate(d.getDate() + add);
    const dow = d.getDay(); // 0 Sun, 6 Sat
    if (dow === 6) d.setDate(d.getDate() + 2);
    else if (dow === 0) d.setDate(d.getDate() + 1);
    return d;
  }
  function fmt(date) {
    try { return date.toLocaleDateString(undefined, { month: "long", day: "numeric" }); }
    catch { return date.toDateString(); }
  }
  function setText(sel, text) {
    const el = document.querySelector(sel);
    if (!el) { console.warn(LOGP, "Target not found:", sel); return false; }
    el.textContent = text;
    return true;
  }
  function readVariantMap() {
    // Prefer JSON block you added
    const el = document.getElementById("variant-processing-time-json");
    if (!el || !el.textContent.trim()) {
      console.warn(LOGP, "variant-processing-time-json not found or empty");
      return null;
    }
    const map = safeParseJSON(el.textContent.trim(), null);
    console.log(LOGP, "Loaded variant map keys:", map ? Object.keys(map).length : 0);
    return map;
  }
  function readFallbackDays() {
    const el = document.querySelector("#dispatch-date");
    const raw = el?.getAttribute("data-date");
    const n = toInt(raw);
    const fallback = Number.isFinite(n) ? n : 28;
    console.log(LOGP, "Product fallback days:", fallback, "(raw:", raw, ")");
    return fallback;
  }
  function getVariantSelect() {
    const s = document.querySelector(".product-single__variants") || document.querySelector('select[name="id"]');
    if (!s) console.warn(LOGP, "Variant <select> not found");
    return s;
  }
  function currentVariantId() {
    const s = getVariantSelect();
    if (s && s.value) return s.value;
    const hid = document.querySelector('input[name="id"][type="hidden"]');
    if (hid && hid.value) return hid.value;
    const dataEl = document.querySelector("[data-variant-id]");
    if (dataEl?.getAttribute("data-variant-id")) return dataEl.getAttribute("data-variant-id");
    console.warn(LOGP, "Could not resolve current variant id");
    return null;
  }

  // --- core -----------------------------------------------------------------
  const variantMap = readVariantMap();
  const productFallbackDays = readFallbackDays();

  function computeDaysForVariant(variantId) {
    if (!variantId) return productFallbackDays;
    // map may contain string keys
    const key = String(variantId);
    const fromMap = variantMap && Object.prototype.hasOwnProperty.call(variantMap, key) ? variantMap[key] : null;
    const asInt = toInt(fromMap);
    const days = Number.isFinite(asInt) ? asInt : productFallbackDays;
    console.log(LOGP, "Variant id:", key, "map value:", fromMap, "→ days used:", days);
    return days;
  }

  function renderDispatch(days) {
    const date = calcNextWeekday(days);
    const formatted = fmt(date);
    console.log(LOGP, "Computed date:", formatted, "(+", days, "days, weekdays-only)");
    const ok1 = setText("#dispatch-date", formatted);
    const ok2 = setText("#dispatch-date_mobile", formatted);
    if (!ok1 && !ok2) console.warn(LOGP, "No dispatch targets updated");
    const hidden = document.querySelector("#dispatch-date-input");
    if (hidden) {
      hidden.value = formatted;
      console.log(LOGP, "Updated #dispatch-date-input:", hidden.value);
    }
  }

  function updateNow(sourceTag) {
    console.log(LOGP, "updateNow() triggered by:", sourceTag);
    const vid = currentVariantId();
    console.log(LOGP, "Current variant id:", vid);
    const days = computeDaysForVariant(vid);
    renderDispatch(days);
  }

  // Initial pass (after your own DOMContentLoaded initializers likely ran)
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(() => updateNow("initial-timeout"), 0);
  } else {
    document.addEventListener("DOMContentLoaded", () => setTimeout(() => updateNow("DOMContentLoaded"), 0));
  }

  // Listen to the SAME radios your code already wired
  document.addEventListener("change", function(e){
    const t = e.target;
    if (!t) return;
    const isOurRadio = t.matches('.product-single__form input[name="Size"], .product-single__form input[name="Color"]');
    if (!isOurRadio) return;

    // Your handler runs first (since it’s bound directly). We queue after it.
    console.log(LOGP, "Radio changed:", t.name, "→", t.value, "— queueing update after your handler...");
    setTimeout(() => updateNow("radio-change"), 0);
  }, true); // capture = true to ensure we always see the event

  // Also react if theme/components fire a change on the select (some do)
  const selectEl = getVariantSelect();
  if (selectEl) {
    selectEl.addEventListener("change", function(){
      console.log(LOGP, "<select> change detected — updating");
      updateNow("select-change");
    });
  } else {
    console.warn(LOGP, "No select to hook; relying on radio changes only");
  }

  // Some themes mutate hidden input[name="id"] instead of firing events
  const hiddenId = document.querySelector('input[name="id"][type="hidden"]');
  if (hiddenId) {
    const mo = new MutationObserver((muts) => {
      if (muts.some(m => m.type === "attributes" && m.attributeName === "value")) {
        console.log(LOGP, "Hidden variant id changed →", hiddenId.value, "— updating");
        updateNow("hidden-id-mutation");
      }
    });
    mo.observe(hiddenId, { attributes: true, attributeFilter: ["value"] });
    console.log(LOGP, "Observing hidden variant id mutations");
  }
})();
/* ============================================================
   SURGICAL RE-CHECK: recompute disabled states per scope
   Scopes:
     1) Main PDP form (form.product-single__form)
     2) Each linked product card (article.linked-product[data-linked-item])
   Triggers:
     - Any option/radio/select change inside PDP or linked cards
     - Section reloads
   ============================================================ */

(function VariantRecheckAll() {
  const LOG = '[recheck]';

  // ---- helpers ------------------------------------------------------------
  const q  = (root, sel) => root ? root.querySelector(sel) : null;
  const qa = (root, sel) => root ? Array.from(root.querySelectorAll(sel)) : [];

  function norm(s) { return (s ?? '').toString().trim(); }
  function readSelected(root, nameLike) {
    // Try radios first
    const r = q(root, `input[type="radio"][name="${nameLike}"]:checked`);
    if (r) return r.value;

    // Try selects with common patterns (theme-agnostic)
    const sel =
      q(root, `select[name="${nameLike}"]`) ||
      q(root, `select[data-index="option2"]`) || // often Color lives on option2
      q(root, `select[data-index="option1"]`) ||
      q(root, `select[name^="options["]`);
    if (sel) return sel.options[sel.selectedIndex]?.text || sel.value;

    // Try swatch labels with "active" markers
    const active = q(root, `.is-selected, [aria-pressed="true"], .active`);
    if (active) return active.textContent;

    return null;
  }

  function findVariantSelect(root) {
    // Prefer the theme’s variant select inside root
    return (
      q(root, '.product-single__variants') ||
      q(root, '[data-variant-select]') ||
      q(root, 'select[name="id"]')
    );
  }

  /**
   * Recompute Size label disabled-state inside a single scope (root).
   * Uses ONLY that scope’s select/options + currently selected Color in that scope.
   */
  function revalidateSizeInScope(root) {
    if (!root) return;
    const selectEl = findVariantSelect(root);
    if (!selectEl || !selectEl.options || !selectEl.options.length) return;

    const selectedColor = norm(readSelected(root, 'Color'));
    if (!selectedColor) return; // no color context → do nothing

    // Sizes: radios with name="Size" inside this scope only
    const sizeRadios = qa(root, 'input[name="Size"]');
    if (!sizeRadios.length) return;

    sizeRadios.forEach((radio) => {
      const sizeValue = norm(radio.value);
      const labelEl = q(root, `label[for="${radio.id}"]`);
      if (!sizeValue || !labelEl) return;

      // Build "Size / Color" as it appears in option text
      const comboText = `${sizeValue} / ${selectedColor}`;

      // Look for at least one enabled matching option in THIS scope’s select
      let isComboAvailable = false;
      for (let i = 0; i < selectEl.options.length; i++) {
        const opt = selectEl.options[i];
        const text = norm(opt.textContent);
        if (text.indexOf(comboText) === 0 && !opt.disabled) {
          isComboAvailable = true;
          break;
        }
      }

      // Toggle only this scope's label (and optionally input)
      labelEl.classList.toggle('disabled', !isComboAvailable);
      // If you want to hard-disable the input too, uncomment:
      // radio.disabled = !isComboAvailable;
    });
  }

  function revalidateScope(root) {
    try {
      revalidateSizeInScope(root);
      // If you also have per-scope COLOR disabling logic, add it here similarly.
    } catch (e) {
      console.warn(LOG, 'scope error', e);
    }
  }

  function revalidateAllScopes() {
    // 1) Main PDP
    const mainForm = document.querySelector('form.product-single__form');
    if (mainForm) revalidateScope(mainForm);

    // 2) Each linked product card (handles #1, #2, etc. independently)
    document.querySelectorAll('article.linked-product[data-linked-item]').forEach((card) => {
      revalidateScope(card);
    });
  }

  // ---- wiring -------------------------------------------------------------
  // Debounced runner (queue after other handlers mutate DOM)
  let t = null;
  function queueRecheck() {
    if (t) cancelAnimationFrame(t);
    t = requestAnimationFrame(revalidateAllScopes);
  }

  // Any change inside PDP or linked cards triggers a recheck
  document.addEventListener('change', (e) => {
    if (
      e.target.closest('form.product-single__form') ||
      e.target.closest('article.linked-product[data-linked-item]')
    ) {
      queueRecheck();
    }
  }, true);

  // Some themes only toggle on click; also queue after clicks
  document.addEventListener('click', (e) => {
    if (
      e.target.closest('form.product-single__form') ||
      e.target.closest('article.linked-product[data-linked-item]')
    ) {
      // queue after microtasks to let other listeners finish
      setTimeout(queueRecheck, 0);
    }
  }, true);

  // Initial + on section reloads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueRecheck);
  } else {
    queueRecheck();
  }
  document.addEventListener('shopify:section:load', queueRecheck);

  // Optional: whenever the variant <select> in any scope changes (some themes use it)
  document.addEventListener('change', (e) => {
    if (e.target.matches('.product-single__variants, [data-variant-select], select[name="id"]')) {
      queueRecheck();
    }
  }, true);
})();
/* ============================================================================
   READY-TO-WEAR DISPATCH DATE VISIBILITY HOOK 
   - Hides the entire "DISPATCH ON {date}" line using visibility:hidden
   - Keeps the <h3> READY TO WEAR always visible
   - Availability is read from the Add-to-Cart button (your script already
     toggles .disabled / [disabled] correctly)
   ========================================================================== */
(function ReadyToWearDateVisibilityHook() {
  const LOG = '[rtw-date]';

  // ---- availability helpers ----------------------------------------------
  function getMainATC() {
    const form = document.querySelector('form.product-single__form');
    if (!form) return null;
    return form.querySelector('.add-to-cart:not(#BIS_trigger)');
  }

  function isCurrentVariantAvailable() {
    const btn = getMainATC();
    if (!btn) {
      console.warn(LOG, 'ATC not found; assuming available');
      return true;
    }

    const hasClass = btn.classList.contains('disabled');
    const hasAttr  = btn.hasAttribute('disabled');
    const available = !(hasClass || hasAttr);

    console.log(
      LOG,
      'ATC state → class.disabled =', hasClass,
      ', disabled attr =', hasAttr,
      '→ available =', available
    );

    return available;
  }

  // ---- RTW block helpers --------------------------------------------------
  function getRTWBlocks() {
    const spans = [
      document.getElementById('dispatch-date-rtw'),
      document.getElementById('dispatch-date-rtw_mobile')
    ].filter(Boolean);

    return spans.map(span => {
      const p = span.closest('p') || span.parentElement;
      const block = p ? p.parentElement : null; // wrap <div>
      return { span, p, block };
    }).filter(item => item.block);
  }

  function updateRTWDateVisibility(sourceTag) {
    console.log(LOG, 'updateRTWDateVisibility triggered by:', sourceTag);

    const available = isCurrentVariantAvailable();
    const blocks = getRTWBlocks();

    blocks.forEach(({ span, block }) => {
      // Save original text once
      if (!span.dataset.rtwOriginalText) {
        span.dataset.rtwOriginalText = span.textContent || '';
      }

      if (!available) {
        // OUT OF STOCK → hide with visibility (layout preserved)
        block.style.visibility = 'hidden';
        console.log(LOG, 'OOS → hiding via visibility for', span.id);
      } else {
        // AVAILABLE → show it again
        block.style.visibility = 'visible';
        if (!span.textContent && span.dataset.rtwOriginalText) {
          span.textContent = span.dataset.rtwOriginalText;
        }
        console.log(LOG, 'Available → showing via visibility for', span.id);
      }
    });
  }

  // ---- wire events --------------------------------------------------------
  function wireEvents() {
    // Initial run — delayed to wait for your core script to finish
    updateRTWDateVisibility('init-immediate');
    setTimeout(() => updateRTWDateVisibility('init-delay-200ms'), 200);

    // When Size/Color radios change
    document.addEventListener(
      'change',
      function (e) {
        const t = e.target;
        if (!t) return;

        if (
          t.matches('.product-single__form input[name="Size"]') ||
          t.matches('.product-single__form input[name="Color"]')
        ) {
          setTimeout(() => updateRTWDateVisibility('radio-change'), 0);
        }
      },
      true
    );

    // Observe ATC mutations — whenever your system toggles availability
    const atc = getMainATC();
    if (atc) {
      const mo = new MutationObserver(muts => {
        if (
          muts.some(m =>
            m.type === 'attributes' &&
            (m.attributeName === 'class' || m.attributeName === 'disabled')
          )
        ) {
          setTimeout(() => updateRTWDateVisibility('atc-mutation'), 0);
        }
      });
      mo.observe(atc, { attributes: true, attributeFilter: ['class', 'disabled'] });
      console.log(LOG, 'Observing ATC for visibility updates');
    }

    // On section reload
    document.addEventListener('shopify:section:load', () => {
      setTimeout(() => updateRTWDateVisibility('section-load'), 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireEvents);
  } else {
    wireEvents();
  }
})();

